type Parent = Document | ShadowRoot | HTMLElement | DocumentFragment
export function getElement<T extends HTMLElement>(
	query: string,
	parent: Parent,
	ElementType: new () => T,
): T
export function getElement(
	query: string,
	parent: Parent,
	ElementType?: new () => HTMLElement,
): HTMLElement
export function getElement(
	query: string,
	parent: Parent,
	ElementType: new () => HTMLElement = HTMLElement,
) {
	const element = parent.querySelector(query)
	if (element == null) {
		throw new Error(`Element not found: ${query}`)
	}
	if (!(element instanceof ElementType)) {
		throw new Error(`Element is not of type ${ElementType.name}: ${query}`)
	}
	return element as InstanceType<typeof ElementType>
}

export function getElements<
	M extends Record<
		string,
		{ query: string; elementClass?: new () => HTMLElement }
	>,
>(elements: M, parent: Document | ShadowRoot): ElementMapFromConstructorMap<M> {
	const result: Record<string, HTMLElement> = {}
	for (const [key, { query, elementClass }] of Object.entries(elements)) {
		result[key] = getElement(query, parent, elementClass)
	}
	return result as ElementMapFromConstructorMap<M>
}

type ElementMapFromConstructorMap<
	T extends Record<
		string,
		{ query: string; elementClass?: new () => HTMLElement }
	>,
> = {
	[K in keyof T]: T[K] extends {
		elementClass: infer C extends new () => HTMLElement
	}
		? InstanceType<C>
		: HTMLElement
}
